import { render } from "./SilverHonorBlog.vue?vue&type=template&id=4b5f4566"
import script from "./SilverHonorBlog.vue?vue&type=script&lang=js"
export * from "./SilverHonorBlog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__